import { CREATE_ERROR, CLEAR_ERROR } from '../types/errorTypes';
import { ACCOUNT_LOGOUT } from '../types/accountTypes';

const errorReducer = (initialState = {}, action) => {
  switch (action.type) {
    case CREATE_ERROR:
      return {
        code: action.payload.code,
        message: action.payload.message,
        enabled: true,
      };
    case CLEAR_ERROR:
    case ACCOUNT_LOGOUT:
      return {
        code: undefined,
        message: undefined,
        enabled: false,
        reconnectingTrays: 0,
      };
    default:
      return initialState;
  }
};

export default errorReducer;
